<a href="#" class="color-cerulean cellAction" (click)="onDashboardClick($event)">
    <span *ngIf="value">{{ value }}</span>
    <i *ngIf="!value" cvLocalizedText langSection="Dashboards_Landing" langKey="No_Name">No Name</i>
</a>
<svg class="mx-1 icon-12 fill-valyrianSteel" *ngIf="params?.data?.NumRecipientLogins > 0">
    <use href="../App_Themes/clearview-default/icons/utility/share.svg#share"></use>
</svg>
<svg class="mx-1 icon-12 fill-valyrianSteel" *ngIf="params?.data?.IsSubscribed">
    <use href="../App_Themes/clearview-default/icons/utility/subscribe.svg#subscribe"></use>
</svg>
